import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-addcase-search',
    templateUrl: './addcase-search.component.html',
    styleUrls: ['./addcase-search.component.scss'],
    standalone: false
})
export class AddcaseSearchComponent implements OnInit {
  public showSuggest = false;

  constructor() { }

  ngOnInit() {
  }

}
